import { Helmet } from 'react-helmet-async'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

const TermsPage = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service - DevSecRoot</title>
        <meta name="description" content="DevSecRoot's terms of service - the terms and conditions for using our services." />
        <link rel="canonical" href="https://devsecroot.com/terms" />
      </Helmet>

      <section className="pt-32 pb-16">
        <div className="container-max">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-dsr-text mb-6">
              Terms of Service
            </h1>
            <p className="text-xl text-dsr-text/70 max-w-2xl mx-auto">
              The terms and conditions for using our services
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="glass-card-hover p-8 max-w-4xl mx-auto"
          >
            <div className="prose prose-invert max-w-none">
              <p className="text-dsr-text/70 mb-6">
                <strong>Last updated:</strong> {new Date().toLocaleDateString()}
              </p>

              <h2 className="text-2xl font-bold text-dsr-text mb-4">Acceptance of Terms</h2>
              <p className="text-dsr-text/70 mb-6">
                By accessing and using DevSecRoot's services, you accept and agree to be bound by 
                the terms and provision of this agreement.
              </p>

              <h2 className="text-2xl font-bold text-dsr-text mb-4">Services</h2>
              <p className="text-dsr-text/70 mb-6">
                DevSecRoot provides security assessment, development services, and consulting. 
                We reserve the right to modify or discontinue any service at any time.
              </p>

              <h2 className="text-2xl font-bold text-dsr-text mb-4">Client Responsibilities</h2>
              <p className="text-dsr-text/70 mb-6">
                Clients are responsible for providing accurate information, cooperating with our team, 
                and implementing recommended security measures.
              </p>

              <h2 className="text-2xl font-bold text-dsr-text mb-4">Intellectual Property</h2>
              <p className="text-dsr-text/70 mb-6">
                All intellectual property created by DevSecRoot remains our property unless 
                otherwise specified in a written agreement.
              </p>

              <h2 className="text-2xl font-bold text-dsr-text mb-4">Limitation of Liability</h2>
              <p className="text-dsr-text/70 mb-6">
                DevSecRoot's liability is limited to the amount paid for services. 
                We are not liable for indirect, incidental, or consequential damages.
              </p>

              <h2 className="text-2xl font-bold text-dsr-text mb-4">Confidentiality</h2>
              <p className="text-dsr-text/70 mb-6">
                We maintain strict confidentiality of client information and project details 
                in accordance with our confidentiality agreements.
              </p>

              <h2 className="text-2xl font-bold text-dsr-text mb-4">Contact Us</h2>
              <p className="text-dsr-text/70 mb-6">
                If you have questions about these terms, please contact us at{' '}
                <a href="mailto:legal@devsecroot.com" className="text-dsr-accent hover:text-cyan-400">
                  legal@devsecroot.com
                </a>
              </p>

              <div className="mt-8 pt-6 border-t border-white/10">
                <Link to="/contact" className="btn-primary">
                  Contact Us
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  )
}

export default TermsPage
